import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=86c12284&scoped=true"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"
import style0 from "./Test.vue?vue&type=style&index=0&id=86c12284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c12284",
  null
  
)

export default component.exports